module.exports = "{{if data.length > 0}} <span class=\"txt_bar\">&nbsp;|&nbsp;</span> <span class=\"png_comm ico_ccl1\">저작권 표시</span> {{for data}} <span class=\"png_comm ico_ccl{{:icon_code}}\">{{:desc}}</span> {{/for}} {{/if}}";


/*****************
 ** WEBPACK FOOTER
 ** ./src/IIM/core/templates/ccl.hbs
 ** module id = 27
 ** module chunks = 0 1
 **/